import React from "react";
import { connect } from "react-redux";

import AdminAddRecipe from "./adminAddRecipe";
import UserAddRecipe from "./userAddRecipe";

const AddRecipe = ({ match, isAdmin, history }) => {
	return isAdmin ? <AdminAddRecipe match={match} /> : <UserAddRecipe history={history} />;
};

const mapStateToProps = (state) => {
	return {
		isAdmin: state.Auth.isAdmin
	};
};

export default connect(mapStateToProps)(AddRecipe);
